(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

 customElements.define('sticky-header', StickyHeader);

function updateHeaderHeight() {
  const header = document.querySelector('.custom-header');
  if (!header) return;

  // Calculate the height safely
  const headerHeight = header.getBoundingClientRect().height;
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}

// Run when DOM is fully loaded (not just on window load)
document.addEventListener('DOMContentLoaded', updateHeaderHeight);

// Recalculate on full load (fonts, images, etc.)
window.addEventListener('load', updateHeaderHeight);

// Throttle resize handler for performance
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(updateHeaderHeight, 150);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-film-duo"] && !Shopify.designMode) return;
  try {
    
  class LbxFilmDuo extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.items = [].slice.call(this.querySelectorAll('[data-item]'));
      this.items.forEach(function (item) {
        var frame = item.querySelector('[data-frame]');
        item._cover = frame ? frame.innerHTML : '';
      });
      this.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('[data-play]') : null;
        if (!btn || !self.contains(btn)) return;
        self.start(btn.closest('[data-item]'));
      });
    }
    start(item) {
      var frame = item && item.querySelector('[data-frame]');
      var tpl = item && item.querySelector('template[data-player]');
      if (!frame || !tpl) return;
      this.items.forEach(function (other) { if (other !== item) LbxFilmDuo.stop(other); });
      frame.textContent = '';
      frame.appendChild(tpl.content.cloneNode(true));
      var media = frame.querySelector('video, iframe');
      if (media) {
        if (media.tagName === 'VIDEO') { try { media.play(); } catch (err) {} }
        media.focus();
      }
    }
    static stop(item) {
      var frame = item.querySelector('[data-frame]');
      var media = frame && frame.querySelector('video, iframe');
      if (!media) return;
      if (media.tagName === 'VIDEO') { try { media.pause(); } catch (err) {} }
      else { frame.innerHTML = item._cover; }
    }
  }
  if (!customElements.get('lbx-film-duo')) customElements.define('lbx-film-duo', LbxFilmDuo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-film"] && !Shopify.designMode) return;
  try {
    
  class LbxFilm extends HTMLElement {
    connectedCallback() {
      var self = this;
      var frame = this.querySelector('[data-frame]');
      var play = this.querySelector('[data-play]');
      var tpl = this.querySelector('template[data-player]');
      if (!frame || !play || !tpl) return;
      play.addEventListener('click', function () {
        frame.textContent = '';
        frame.appendChild(tpl.content.cloneNode(true));
        var media = frame.querySelector('video, iframe');
        if (media) {
          if (media.tagName === 'VIDEO') { try { media.play(); } catch (e) {} }
          media.focus();
        }
      }, { once: true });
    }
  }
  if (!customElements.get('lbx-film')) customElements.define('lbx-film', LbxFilm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lookbook-stories')) return;

    class LookbookStories extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.stage = this.querySelector('[data-stage]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
        if (!this.stage || !this.slides.length) return;

        this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-group]'));
        this.fills = Array.prototype.slice.call(this.querySelectorAll('[data-fill]'));
        this.pauseBtn = this.querySelector('[data-pause]');
        this.shareBtn = this.querySelector('[data-share]');
        this.live = this.querySelector('[data-live]');
        this.count = this.slides.length;
        this.duration = Number(this.dataset.duration) || 6000;

        var designMode = !!(window.Shopify && window.Shopify.designMode);
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.index = 0;
        this.elapsed = 0;
        this.userPaused = reduced; // autoplays by default; only reduced-motion users start paused
        this.held = false;
        this.hovering = false;
        this.offscreen = false;
        this.completed = false; // true once the first full pass has played
        this.loading = false;
        this._raf = 0;
        this._last = 0;
        this._lastPointer = 0;
        this._started = false;
        this._tick = this._tick.bind(this);
        this._update = this._update.bind(this);

        document.documentElement.classList.add('lb-in-view');
        var header = document.querySelector('.shopify-section-group-header-group');
        if (header) this.style.setProperty('--lb-offset', header.offsetHeight + 'px');

        this.classList.add('is-booting');
        this._bindControls();
        this._bindPointer();
        this._bindEnvironment();

        var match = /^#look-(\d+)$/.exec(window.location.hash || '');
        this.goTo(match ? Math.min(Math.max(Number(match[1]), 1), this.count) - 1 : 0, false);
        this._started = true;
        this._syncPauseUI();

        var self = this;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { self.classList.remove('is-booting'); });
        });
      }

      disconnectedCallback() {
        if (!this._ready) return;
        cancelAnimationFrame(this._raf);
        this._raf = 0;
        document.documentElement.classList.remove('lb-in-view');
        document.removeEventListener('keydown', this._onKey);
        document.removeEventListener('visibilitychange', this._update);
        window.removeEventListener('pageshow', this._onPageShow);
        if (this._io) this._io.disconnect();
        this._ready = false;
      }

      /* ---------- navigation ---------- */

      next(user) {
        if (this.index < this.count - 1) {
          this.goTo(this.index + 1, user);
        } else {
          // Last look: report the first full pass, then loop back to the start
          if (!this.completed) { this.completed = true; this._track('lookbook_complete'); }
          this.goTo(0, user);
        }
      }

      prev(user) {
        this.goTo(Math.max(this.index - 1, 0), user); // on the first look this restarts it
      }

      goTo(i, user) {
        i = Math.max(0, Math.min(this.count - 1, i));

        this.index = i;
        this.elapsed = 0;

        for (var n = 0; n < this.count; n++) {
          var on = n === i;
          this.slides[n].classList.toggle('is-active', on);
          this.slides[n].classList.toggle('is-before', n < i);
          if (on) this.slides[n].removeAttribute('aria-hidden');
          else this.slides[n].setAttribute('aria-hidden', 'true');
          if (this.groups[n]) this.groups[n].classList.toggle('is-active', on);
          if (this.fills[n]) this.fills[n].style.transform = 'scaleX(' + (n < i ? 1 : 0) + ')';
        }

        // Load this look and the next few; hold the timer until the current image is ready
        for (var k = i - 1; k <= i + 2; k++) this._load(this.slides[k]);
        var img = this.slides[i].querySelector('img');
        this.loading = !!(img && !(img.complete && img.naturalWidth > 0));
        if (this.loading) {
          var self = this;
          var done = function () { self.loading = false; self._update(); };
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        }

        if (this._started) {
          try { history.replaceState(null, '', '#look-' + (i + 1)); } catch (e) {}
        }
        this._track('lookbook_view');
        if (user) this._announce('Look ' + (i + 1) + ' of ' + this.count);
        this._update();
      }

      /* ---------- timer ---------- */

      _running() {
        return !this.userPaused && !this.held && !this.hovering && !this.offscreen &&
               !this.loading && !document.hidden;
      }

      _update() {
        if (!this._ready) return;
        if (this._running() && !this._raf) {
          this._last = performance.now();
          this._raf = requestAnimationFrame(this._tick);
        }
      }

      _tick(now) {
        this._raf = 0;
        if (!this._running()) return;
        var dt = Math.min(Math.max(now - this._last, 0), 100);
        this._last = now;
        this.elapsed += dt;
        var p = Math.min(this.elapsed / this.duration, 1);
        this.fills[this.index].style.transform = 'scaleX(' + p + ')';
        if (p >= 1) {
          this.next(false);
          return;
        }
        this._raf = requestAnimationFrame(this._tick);
      }

      _setHeld(value) {
        this.held = value;
        this.classList.toggle('is-held', value);
        this._update();
      }

      _syncPauseUI() {
        this.classList.toggle('is-paused', this.userPaused);
        if (this.pauseBtn) {
          this.pauseBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
          this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play' : 'Pause');
        }
      }

      /* ---------- input ---------- */

      _bindControls() {
        var self = this;

        // Keyboard / assistive-tech activation of the tap zones (pointer taps are handled on the stage)
        var tap = function (dir) {
          return function () {
            if (performance.now() - self._lastPointer < 800) return;
            if (dir > 0) self.next(true); else self.prev(true);
          };
        };
        var prevBtn = this.querySelector('[data-prev]');
        var nextBtn = this.querySelector('[data-next]');
        if (prevBtn) prevBtn.addEventListener('click', tap(-1));
        if (nextBtn) nextBtn.addEventListener('click', tap(1));

        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', function () {
            self.userPaused = !self.userPaused;
            self._syncPauseUI();
            self._update();
          });
        }

        // Scroll button: jump to the section below the stories (hidden when there isn't one)
        var more = this.querySelector('[data-scroll]');
        if (more) {
          var wrap = this.closest('.shopify-section') || this;
          var below = wrap.nextElementSibling;
          if (below) {
            more.hidden = false;
            more.addEventListener('click', function () {
              var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              below.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
            });
          }
        }

        if (this.shareBtn) {
          if (navigator.share) this.shareBtn.hidden = false;
          this.shareBtn.addEventListener('click', function () {
            var url = window.location.origin + window.location.pathname + '#look-' + (self.index + 1);
            navigator.share({ title: self.dataset.title, url: url })
              .then(function () { self._track('lookbook_share'); })
              .catch(function () {});
          });
        }

        this.addEventListener('click', function (e) {
          var link = e.target.closest && e.target.closest('[data-product]');
          if (link) self._track('lookbook_product_click', { product_title: link.dataset.title });
        });

        // Pause while a mouse rests on a product tile so it can be read and clicked
        this.querySelectorAll('[data-product]').forEach(function (el) {
          el.addEventListener('pointerenter', function (e) {
            if (e.pointerType === 'mouse') { self.hovering = true; }
          });
          el.addEventListener('pointerleave', function (e) {
            if (e.pointerType === 'mouse') { self.hovering = false; self._update(); }
          });
        });

        // Theme editor: selecting a block jumps to that look
        this.addEventListener('shopify:block:select', function (e) {
          for (var n = 0; n < self.slides.length; n++) {
            if (self.slides[n] === e.target || self.slides[n].contains(e.target)) {
              self.userPaused = true; // keep the selected look on screen while editing
              self._syncPauseUI();
              self.goTo(n, false);
              break;
            }
          }
        });
      }

      _bindPointer() {
        var self = this;
        var stage = this.stage;
        var down = null;
        var holdTimer = 0;

        stage.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.target.closest && e.target.closest('[data-ui]')) return;
          self._lastPointer = performance.now();
          down = { id: e.pointerId, x: e.clientX, y: e.clientY, t: performance.now(), moved: false, held: false };
          try { stage.setPointerCapture(e.pointerId); } catch (err) {}
          // Respond on press: after a short hold the screen clears and the timer pauses
          holdTimer = setTimeout(function () {
            if (down && !down.moved) { down.held = true; self._setHeld(true); }
          }, 220);
        });

        stage.addEventListener('pointermove', function (e) {
          if (!down || e.pointerId !== down.id || down.moved) return;
          if (Math.hypot(e.clientX - down.x, e.clientY - down.y) > 10) {
            down.moved = true;
            clearTimeout(holdTimer);
            if (down.held) { down.held = false; self._setHeld(false); }
          }
        });

        var finish = function (e, cancelled) {
          if (!down || e.pointerId !== down.id) return;
          clearTimeout(holdTimer);
          var d = down;
          down = null;
          self._lastPointer = performance.now();
          if (d.held) self._setHeld(false);
          if (cancelled || d.held) return;

          var dx = e.clientX - d.x;
          var dy = e.clientY - d.y;
          if (d.moved) {
            var velocity = dx / Math.max(performance.now() - d.t, 1); // px per ms
            var horizontal = Math.abs(dx) > Math.abs(dy);
            if (horizontal && (Math.abs(dx) > 48 || Math.abs(velocity) > 0.4)) {
              if (dx < 0) self.next(true); else self.prev(true);
            }
            return;
          }

          var rect = stage.getBoundingClientRect();
          if (e.clientX - rect.left < rect.width / 3) self.prev(true);
          else self.next(true);
        };
        stage.addEventListener('pointerup', function (e) { finish(e, false); });
        stage.addEventListener('pointercancel', function (e) { finish(e, true); });
        stage.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      }

      _bindEnvironment() {
        var self = this;

        this._onKey = function (e) {
          if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
          if (self.offscreen) return;
          var tag = e.target && e.target.tagName;
          if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
          var t = e.target;
          if (t && (/^(input|textarea|select)$/i.test(t.tagName) || t.isContentEditable)) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); self.next(true); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); self.prev(true); }
        };
        document.addEventListener('keydown', this._onKey);
        document.addEventListener('visibilitychange', this._update);

        // Coming back from a product page via the back/forward cache: clear any stale hover/hold state
        this._onPageShow = function (e) {
          if (e.persisted) { self.hovering = false; self.held = false; self.classList.remove('is-held'); self._update(); }
        };
        window.addEventListener('pageshow', this._onPageShow);

        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver(function (entries) {
            self.offscreen = !entries[0].isIntersecting;
            document.documentElement.classList.toggle('lb-in-view', !self.offscreen);
            self._update();
          }, { threshold: 0.35 });
          this._io.observe(this);
        }
      }

      /* ---------- helpers ---------- */

      _load(slide) {
        if (!slide || slide.dataset.loaded) return;
        slide.dataset.loaded = '1';
        slide.querySelectorAll('source[data-srcset]').forEach(function (s) { s.srcset = s.dataset.srcset; });
        var img = slide.querySelector('img[data-src]');
        if (img) {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
        }
      }

      _announce(text) {
        if (!this.live) return;
        var live = this.live;
        live.textContent = '';
        setTimeout(function () { live.textContent = text; }, 30);
      }

      _track(name, extra) {
        try {
          var payload = { event: name, lookbook_title: this.dataset.title, lookbook_index: this.index + 1 };
          if (extra) for (var key in extra) payload[key] = extra[key];
          (window.dataLayer = window.dataLayer || []).push(payload);
        } catch (e) {}
      }
    }

    customElements.define('lookbook-stories', LookbookStories);
  })();

  } catch(e) { console.error(e); }
})();
})();
